import unescape from 'lodash/unescape';
import React from 'react';
import PropTypes from 'prop-types';
import Link from 'router/Link';
import Breadcrumbs from './Breadcrumbs';
import Breadcrumb from './Breadcrumb';

const SearchBreadcrumbsDesktop = ({
    data: {
        city: {relativeUrl, displayName},
        extraBreadcrumb: {url: extraUrl, label: extraLabel},
        activeBreadcrumb: {url, label},
    },
}) => {
    if (label === 'Current Location') {
        return (
            <Breadcrumbs>
                <Breadcrumb
                    className="SearchBreadcrumb-active"
                    label={unescape(label)}
                    active
                />
            </Breadcrumbs>
        );
    }

    return (
        <Breadcrumbs>
            <Breadcrumb>
                <Link to={relativeUrl}>
                    <span>{unescape(displayName)}</span>
                </Link>
            </Breadcrumb>
            {extraUrl && (
                <Breadcrumb>
                    <Link to={extraUrl}>{unescape(extraLabel)}</Link>
                </Breadcrumb>
            )}
            {url ? (
                <Breadcrumb className="SearchBreadcrumb-active" active>
                    <Link to={url}>{unescape(label)}</Link>
                </Breadcrumb>
            ) : (
                <Breadcrumb
                    className="SearchBreadcrumb-active"
                    label={unescape(label)}
                    active
                />
            )}
        </Breadcrumbs>
    );
};

SearchBreadcrumbsDesktop.propTypes = {
    data: PropTypes.object.isRequired,
};

export default SearchBreadcrumbsDesktop;
